import script from "./MemoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MemoModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__